// Formatting helper for number inputs that may use comma as decimal separator.
// Converts localized numeric strings to JS number.
export function toNumber(value: string): number {
  return Number(value.replace(/,/g, '.'))
}

/** Like `toNumber`, but an empty input (or a lone separator) is no value rather than 0. */
export function toOptionalNumber(value: string): number | undefined {
  return /\d/.test(value) ? toNumber(value) : undefined
}
